import React from "react";
import CodeSnippet from "../index-sections/CodeSnippet.js";

import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

import Navbar from "components/Navbars/IndexNavbar";
import Header from "components/Headers/IndexHeader";
import Footer from "components/Footers/DemoFooter.js";

function AsyncAwait() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  return (
    <>
        {/* Navbar */}
        <Navbar />

        {/* Header */}
        <Header />
        
        {/* Inizio del contenuto della pagina */}
        <div className="main">
            <div className="section text-center">
                {/* Inizio del container */}
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Async & Await</h2>
                            {/* Descrizione */}
                            <h5 className="description">
                            Async e Await sono 2 parole chiave che abilitano la gestione di funzioni asincrone eseguite tramite un approccio sincrono.
                            <br />Gli approcci generalmente più utilizzati per l'esecuzione di operazioni asincrone in JavaScript sono 2: le funzioni di callback (funzioni passate come parametri ad altre funzioni) e le Promise (oggetti utilizzati per rappresentare lo stato di esecuzione di una attività asincrona).
                            </h5>
                            <br />
                        </Col>
                    </Row>
                </Container>
                {/* Fine del container */}
            </div>


            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="javascript"
                description="Attraverso il seguente codcie viene mostrato come una funzione ASINCRONA come la fetch possa essere utilizzata come funzione sincrona (il console log con il nome e cognome verra stampato solo al termine della fetch)"
                code={`//Questa funzione in realtà sarà inserita in un modulo (non come in questo esempio nel file server.js)

/*
"async"
    - può essere usato su tutte le funzioni
    - async NON CREA FUNZIONI ASINCRONE!
*/
const somma = async()=> {

    /*
    "await"
        - può essere usato SOLO con le funzioni asincrone (come la fetch) e funziona solo con le funzoni async (come "somma" in questo caso)
        - await mi ritorna una promise
    */
    await fetch('https://v2.jokeapi.dev/joke/Programming')
    .then(res => res.json())
    .then(json => console.log(json.joke));
}

/*
Digitando "somma()." vedo che ho 3 opzioni disponibili:
    - .then --> stampo il mio nome (tramite un console log) dopo (then) aver eseguito tutta la funzione "somma"
    - .finally
    - .catch
*/
somma().then(console.log("Mattia Bracco"))`}
            />
            {/* Fine snippet del codice */}

            {/* Inizio button per codice completo */}
            <div className="section text-center">
                <Button className="btn-round mr-1" color="info" outline type="button" href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/async_e_await" target="_blank">
                    Visualizza codice completo
                </Button>
            </div>
            {/* Fine button per codice completo */}
            
        </div>
        {/* Fine del contenuto della pagina */}
        
        {/* Footer */}
        <Footer />
    </>
  );
}

export default AsyncAwait;
